import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import LookupField from '../../ui/lookup/LookupField';
import { DateRenderer, DateTimeRenderer, TextAlignLeftRenderer } from '../SmartTableRenderers';

import ApplicationContext from '../../ApplicationContext';
import { TableColumn } from '../../tableSettings';
import { SQLIndex } from '../../fms.core/constants';
import { LookupCopyInvTargetAcct } from '../../fms.data/lookup';
import { JobNames } from '../../framework.core/JobNames';

function CopyInvTargetAcctLookupFieldLookupField({
  initialValue = '',
  onSelect = () => {},
  placeholder = undefined,
  onTextChange = () => {},
  disabled = false,
  lookupId = undefined,
  onTabNext = undefined,
  onTabPrevious = undefined,
  maxLength = undefined,
  jobType,
  parent
}: {
  disabled?: boolean,
  initialValue: string,
  onSelect: (x:LookupCopyInvTargetAcct) => void,
  placeholder: string|undefined,
  onTextChange: (text:string|undefined) => void,
  lookupId?: string|undefined,
  onTabNext?: (() => boolean)|undefined,
  onTabPrevious?: (() => boolean)|undefined,
  maxLength?: number|undefined,
  jobType: JobNames,
  parent: JobNames,
}) {
  const appContext = useContext(ApplicationContext);

  async function queryCopyInvRefNo(queryString:string|null) {
    const apiResult = await appContext.api.getLookupItems(SQLIndex.CopyInvFromAcct, queryString ?? '', jobType, parent);
    return apiResult?.entities;
  }
  function onCancel() {
  }

  function filter(data:Array<LookupCopyInvTargetAcct>, filterText:string) {
    return data.filter(x =>
      (x.invNo && x.invNo.toLowerCase().startsWith(filterText.toLowerCase()))||
      (x.entity && x.entity.toLowerCase().startsWith(filterText.toLowerCase()))
      );
  }


  let dateLabel, noLabel, entityLabel, blnoLabel;

  switch (jobType) {
    case JobNames.Bill:
      dateLabel = 'Bill Date';
      entityLabel = 'Vendor';
      noLabel = "Bill #";
      blnoLabel = "B/L #";
      break;
    case JobNames.Invoice:
      dateLabel = 'Invoice Date';
      entityLabel = 'Invoice To';
      noLabel = "Invoice #";
      blnoLabel = "B/L #";
      break;

  }

  const columns:Array<TableColumn> = [
    { Header: dateLabel, accessor: 'invDate', resizable: false, sortable: false, canBeHidden: false, visible: true, width: 100, Cell: DateRenderer },
    { Header: blnoLabel, accessor: 'blNo', resizable: false, sortable: false, canBeHidden: false, visible: true, width: 100, Cell: TextAlignLeftRenderer },
    { Header: noLabel, accessor: 'invNo', resizable: false, sortable: false, canBeHidden: false, visible: true, width: 100, Cell: TextAlignLeftRenderer },
    { Header: entityLabel, accessor: 'entity', resizable: false, sortable: false, canBeHidden: false, visible: true, width: 100, Cell: TextAlignLeftRenderer },
    { Header: 'Create Date', accessor: 'createDate', resizable: false, sortable: false, canBeHidden: false, visible: true, width: 100, Cell: DateTimeRenderer },
  ];

  return (
    <LookupField
      lookupId={lookupId}
      onTabNext={onTabNext}
      onTabPrevious={onTabPrevious}
      disabled={disabled}
      query={queryCopyInvRefNo}
      width="520px"
      columns={columns} 
      onSelect={onSelect}
      onCancel={onCancel}
      labelProp="invNo"
      initialValue={initialValue}
      placeholder={placeholder}
      onTextChange={onTextChange}
      filter={filter}
      maxLength={maxLength}
      />
  );
}

CopyInvTargetAcctLookupFieldLookupField.defaultProps = {
  onSelect: () => {},
  onTextChange: () => {},
  disabled: false,
};

CopyInvTargetAcctLookupFieldLookupField.propTypes = {
  initialValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  lookupId: PropTypes.string,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
  maxLength: PropTypes.number,
  jobType: PropTypes.string,
  parent: PropTypes.string,
};


export default React.memo(CopyInvTargetAcctLookupFieldLookupField);
